module.exports = __webpack_public_path__ + "img/img94.1d9d1aa6.png";